import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import store from "./state/store";
import Axios from "@/config/axios";

import BootstrapVue3 from "bootstrap-vue-3";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import Maska from "maska";

import VueFeather from "vue-feather";
import Particles from "particles.vue3";

import CKEditor from "@ckeditor/ckeditor5-vue";
import myUpload from "vue-image-crop-upload";

import "@/assets/scss/config/material/app.scss";
import "@vueform/slider/themes/default.css";

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

const MIME_EXTENSIONS = {
  "image/avif": "avif",
  "image/gif": "gif",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
};

/**
 * Televerse une image et renvoie son URL publique absolue.
 *
 * L'upload passe par l'API admin, qui pousse ensuite vers Supabase Storage :
 * la cle secrete du stockage ne quitte jamais le serveur.
 *
 * `source` est la data URL produite par vue-image-crop-upload. Si c'est deja
 * une URL absolue (cas d'une image laissee inchangee dans un formulaire), on la
 * renvoie telle quelle sans re-televerser.
 */
async function uploadFile(source, name) {
  if (typeof source !== "string" || /^https?:\/\//i.test(source)) {
    return source;
  }

  const blob = await (await fetch(source)).blob();
  const extension = MIME_EXTENSIONS[blob.type];

  if (!extension) {
    throw new Error("Format d'image non supporte : " + (blob.type || "inconnu"));
  }

  const form = new FormData();
  form.append("img", blob, name + "." + extension);
  form.append("name", name);

  // axios retire le Content-Type JSON par defaut quand le corps est un
  // FormData, laissant le navigateur poser la frontiere multipart.
  const { data } = await Axios.post("/admin/app-settings/upload", form);

  return data.url;
}

const app = createApp(App);

app.config.globalProperties.$upload_file = uploadFile;

app
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(CKEditor)
  .use(BootstrapVue3)
  .component(VueFeather.type, VueFeather)
  .component("my-upload", myUpload)
  .use(Maska)
  .use(Particles)
  .use(i18n)
  .use(vClickOutside)
  .mount("#app");
